/**
 * Mock 본인인증 결과 인코더 — 개발 · 테스트 전용.
 *
 * 서버 Mock 어댑터는 base64url(JSON) 을 인증 결과로 받는다. 실제 대행사 연동
 * 전까지 로컬에서 전체 흐름(prepare → 콜백 → ACTIVE)을 완주하는 데 쓴다.
 * (운영 환경은 서버가 mock 어댑터 부팅 자체를 거부한다)
 */
export interface MockVerificationResult {
  readonly transactionId: string;
  readonly ci: string;
  readonly name: string;
  /** YYYY-MM-DD — 서버 만 나이 판정 형식. */
  readonly birthDate: string;
  readonly phone: string;
}

/** UTF-8 안전 base64url 인코딩. (한글 이름 등 멀티바이트 문자 대응) */
export const encodeMockResult = (result: MockVerificationResult): string => {
  const bytes = new TextEncoder().encode(JSON.stringify(result));
  let binary = '';

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/u, '');
};
